module.exports = __webpack_public_path__ + "img/jordbaertaerte.19ba9e5d.jpg";